import { render, staticRenderFns } from "./batch-inform.vue?vue&type=template&id=01457ad9&scoped=true&"
import script from "./batch-inform.vue?vue&type=script&lang=js&"
export * from "./batch-inform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01457ad9",
  null
  
)

export default component.exports